import request from '@/common/request';

// 搜索媒体
export function getMediaByKey(params) {
  return request({ url: '/common/media-list', method: 'get', params });
}

// 搜索栏位
export function getAdslotByKey(params) {
  return request({ url: '/common/adslot-list', method: 'get', params });
}

// 广告数据
export function getAdvDataList(data) {
  return request({ url: '/qunion/ad-data/list', method: 'post', data });
}

export function downloadAdvDataList(data) {
  return request(
    {
      url: '/qunion/ad-data/export',
      method: 'post',
      data,
      responseType: 'arraybuffer',
      // responseType: 'blob',
    },
    true,
  );
}


// 结算数据
export function getMonDataList(data) {
  return request({ url: '/qunion/finance/list', method: 'post', data });
}